import { getBridge } from "../bridge";

// One-time carry-over from the pre-rename (sky-dooh) storage keys, so a player
// that was already paired keeps its identity, schedule and unsent PoP instead
// of re-pairing. Safe to run on every boot: a key is moved only when the new
// one is still empty, and the old one is removed afterwards.

const LEGACY_KEYS: ReadonlyArray<readonly [string, string]> = [
  ["skydooh.device.id", "gocityscreens.device.id"],
  ["skydooh.device.credential", "gocityscreens.device.credential"],
  ["skydooh.device.fingerprint", "gocityscreens.device.fingerprint"],
  ["skydooh.schedule.cache", "gocityscreens.schedule.cache"],
  ["skydooh.pop.buffer", "gocityscreens.pop.buffer"],
];

const LEGACY_MEDIA_CACHE = "skydooh-player-media-v1";

export async function migrateLegacyKeys(): Promise<void> {
  const store = getBridge().secureStore;
  for (const [oldKey, newKey] of LEGACY_KEYS) {
    const value = await store.get(oldKey);
    if (value === null) continue;
    if ((await store.get(newKey)) === null) await store.set(newKey, value);
    await store.remove(oldKey);
  }
  // Media is re-downloaded into the new cache; just free the old one.
  try {
    if (typeof caches !== "undefined") await caches.delete(LEGACY_MEDIA_CACHE);
  } catch {
    /* ignore */
  }
}
